import { CardAction, ChickletHoverActions, ChickletSecondaryDisplayLabels } from '../../constants/BehaviorTypes';
import FlywheelDealCardAction from '../../behaviors/flywheel/deal/FlywheelDealCardAction';
import { getFlywheelDealChickletHoverActions } from '../../behaviors/flywheel/deal/getFlywheelDealChickletHoverActions';
import getDealChickletSecondaryDisplayLabels from '../../behaviors/flywheel/deal/getDealChickletSecondaryDisplayLabels';
export const Deal = {
  [CardAction]: () => FlywheelDealCardAction,
  [ChickletHoverActions]: getFlywheelDealChickletHoverActions,
  [ChickletSecondaryDisplayLabels]: () => getDealChickletSecondaryDisplayLabels
};